import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiInfo } from "react-icons/fi";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import "./LegalPages.css";

export default function TermsAndConditions() {
  const navigate = useNavigate();

  return (
    <div className="layout">
      <Sidebar />
      <div className="content">
        <Header />
        <div className="lgl-page">
          <button className="lgl-back-btn" onClick={() => navigate(-1)}>
            <FiArrowLeft size={14} /> Back
          </button>

          <div className="lgl-card">
            <div className="lgl-card-header">
              <FiInfo size={16} />
              <h2>Terms &amp; Conditions</h2>
            </div>

            <div className="lgl-text">
              <p>
                These terms govern your use of FleetManagementPro. Replace this
                placeholder with your actual terms of service, or fetch it
                from your CMS / backend.
              </p>
              <h3>Acceptance of Terms</h3>
              <p>
                By accessing or using FleetManagementPro, you agree to be bound by
                these terms and conditions.
              </p>
              <h3>Use of the Service</h3>
              <p>
                You agree to use the service only for lawful purposes and in
                accordance with these terms.
              </p>
              <h3>Changes to These Terms</h3>
              <p>
                We may update these terms from time to time. Continued use of
                the service constitutes acceptance of any changes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}